import { useState, useCallback } from "react";
import { getTiposSubproducto } from "../../../services/SubproductoService.js";

const useTiposSubproducto = (baseUrl, empresa) => {
  const [tipoOptions, setTipoOptions] = useState([]);

  const fetchTipos = useCallback(async () => {
    if (!empresa) return;
    try {
      const data = await getTiposSubproducto(baseUrl, empresa);
      setTipoOptions(data);
    } catch (error) {
      console.error("Error al obtener los tipos de subproducto:", error);
    }
  }, [baseUrl, empresa]);

  return { tipoOptions, fetchTipos };
};

export default useTiposSubproducto;
